import React from "react";
import { useLang } from "../i18n/LanguageContext";

const Marquee = () => {
  const { t } = useLang();
  const items = t.marquee;

  return (
    <section
      data-testid="retailers-marquee"
      className="relative bg-brand-navy text-brand-cream py-6 overflow-hidden border-y border-brand-navy/20"
    >
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-brand-navy to-transparent z-10" aria-hidden="true" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-brand-navy to-transparent z-10" aria-hidden="true" />

      <div className="flex w-max animate-marquee whitespace-nowrap">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex items-center gap-10 px-10">
            <span className="font-heading font-black text-xl tracking-tight text-brand-cream/95">
              {items}
            </span>
            <span className="text-brand-red text-2xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
